<template>
  <md-button @click="resetInventory" class="md-primary">
    Resetuj stanje
    <md-icon> refresh </md-icon>
  </md-button>
</template>

<script>
import Swal from 'sweetalert2';
import api from '../api/api';
import services from '../api/services';
export default {
  name: 'ResetInventoryButton',
  props: {
    onReset: Function,
  },
  methods: {
    resetInventory() {
      return Swal.fire({
        title: 'Resetuj stanje magacina?',
        text: `Da li ste sigurni da želite da resetujete stanje svih materijala na 0?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: 'Resetuj!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then((data) => {
        if (!data.value) return;

        api.post(services.itemCount.resetInventory).then(() => {
          this.onReset && this.onReset();
        });
      });
    },
  },
};
</script>
